
const toggleSX = {
  border: "3px solid rgb(56, 52, 220, 0) !important",
  borderRadius: "20px !important",
  padding: "25px",
  lineHeight: "18px",
  textTransform: "none",
  fontWeight: "bold",
  backgroundColor: "rgb(56, 52, 220, 0.15)",
  "&:hover": {
      backgroundColor: "rgb(56, 52, 220, 0.15) !important",
      border: "3px solid rgb(56, 52, 220, 0) !important",
    },
    "&:focus": {
      backgroundColor: "rgb(56, 52, 220, 0.15) !important",
      border: "3px solid rgb(56, 52, 220, 0) !important",
    },
    "&.Mui-selected": {
      backgroundColor: "rgb(56, 52, 220, 0.15) !important",
      border: "3px solid rgb(56, 52, 220, 0.7) !important",
    }, 

};

export default toggleSX